// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file entity/result.proto (package entity, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * Result構造体
 *
 * @generated from message entity.Result
 */
export class Result extends Message<Result> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string category_id = 3 [json_name = "category_id"];
   */
  categoryId = "";

  /**
   * @generated from field: google.protobuf.Timestamp completion_date = 4 [json_name = "completion_date"];
   */
  completionDate?: Timestamp;

  /**
   * @generated from field: entity.ResultMedia main_image = 5 [json_name = "main_image"];
   */
  mainImage?: ResultMedia;

  /**
   * @generated from field: repeated entity.ResultMedia gallery_images = 6 [json_name = "gallery_images"];
   */
  galleryImages: ResultMedia[] = [];

  /**
   * @generated from field: repeated entity.ResultMedia videos = 7;
   */
  videos: ResultMedia[] = [];

  /**
   * @generated from field: string client_name = 8 [json_name = "client_name"];
   */
  clientName = "";

  /**
   * @generated from field: string location = 9;
   */
  location = "";

  /**
   * @generated from field: string site_area = 10 [json_name = "site_area"];
   */
  siteArea = "";

  /**
   * @generated from field: string building_area = 11 [json_name = "building_area"];
   */
  buildingArea = "";

  /**
   * @generated from field: string total_floor_area = 12 [json_name = "total_floor_area"];
   */
  totalFloorArea = "";

  /**
   * @generated from field: string structure_type = 13 [json_name = "structure_type"];
   */
  structureType = "";

  /**
   * @generated from field: string description = 14;
   */
  description = "";

  /**
   * @generated from field: entity.ResultClientInfo client_info = 15 [json_name = "client_info"];
   */
  clientInfo?: ResultClientInfo;

  /**
   * @generated from field: int32 display_priority = 16 [json_name = "display_priority"];
   */
  displayPriority = 0;

  /**
   * @generated from field: bool is_published = 17 [json_name = "is_published"];
   */
  isPublished = false;

  /**
   * @generated from field: string environment = 18;
   */
  environment = "";

  /**
   * @generated from field: google.protobuf.Timestamp create_date = 19 [json_name = "create_date"];
   */
  createDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_date = 20 [json_name = "update_date"];
   */
  updateDate?: Timestamp;

  /**
   * @generated from field: string version = 21;
   */
  version = "";

  constructor(data?: PartialMessage<Result>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.Result";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_id", jsonName: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "completion_date", jsonName: "completion_date", kind: "message", T: Timestamp },
    { no: 5, name: "main_image", jsonName: "main_image", kind: "message", T: ResultMedia },
    { no: 6, name: "gallery_images", jsonName: "gallery_images", kind: "message", T: ResultMedia, repeated: true },
    { no: 7, name: "videos", kind: "message", T: ResultMedia, repeated: true },
    { no: 8, name: "client_name", jsonName: "client_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "site_area", jsonName: "site_area", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "building_area", jsonName: "building_area", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "total_floor_area", jsonName: "total_floor_area", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "structure_type", jsonName: "structure_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "client_info", jsonName: "client_info", kind: "message", T: ResultClientInfo },
    { no: 16, name: "display_priority", jsonName: "display_priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "is_published", jsonName: "is_published", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "create_date", jsonName: "create_date", kind: "message", T: Timestamp },
    { no: 20, name: "update_date", jsonName: "update_date", kind: "message", T: Timestamp },
    { no: 21, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Result {
    return new Result().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Result {
    return new Result().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Result {
    return new Result().fromJsonString(jsonString, options);
  }

  static equals(a: Result | PlainMessage<Result> | undefined, b: Result | PlainMessage<Result> | undefined): boolean {
    return proto3.util.equals(Result, a, b);
  }
}

/**
 *
 *
 * @generated from message entity.ResultMedia
 */
export class ResultMedia extends Message<ResultMedia> {
  /**
   * ファイル名
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * ファイルサイズ（バイト）
   *
   * @generated from field: int64 size = 2;
   */
  size = protoInt64.zero;

  /**
   * MIMEタイプ（image/jpeg, video/mp4など）
   *
   * @generated from field: string content_type = 3 [json_name = "content_type"];
   */
  contentType = "";

  /**
   * メディアタイプ（image/video）
   *
   * @generated from field: string media_type = 4 [json_name = "media_type"];
   */
  mediaType = "";

  /**
   * R2ストレージパス
   *
   * @generated from field: string storage_path = 5 [json_name = "storage_path"];
   */
  storagePath = "";

  /**
   * 表示順序
   *
   * @generated from field: int32 display_order = 6 [json_name = "display_order"];
   */
  displayOrder = 0;

  /**
   * キャプション（任意）
   *
   * @generated from field: string caption = 7;
   */
  caption = "";

  constructor(data?: PartialMessage<ResultMedia>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.ResultMedia";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "content_type", jsonName: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media_type", jsonName: "media_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "storage_path", jsonName: "storage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "display_order", jsonName: "display_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResultMedia {
    return new ResultMedia().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResultMedia {
    return new ResultMedia().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResultMedia {
    return new ResultMedia().fromJsonString(jsonString, options);
  }

  static equals(a: ResultMedia | PlainMessage<ResultMedia> | undefined, b: ResultMedia | PlainMessage<ResultMedia> | undefined): boolean {
    return proto3.util.equals(ResultMedia, a, b);
  }
}

/**
 *
 *
 * @generated from message entity.ResultClientInfo
 */
export class ResultClientInfo extends Message<ResultClientInfo> {
  /**
   * 企業名
   *
   * @generated from field: string company_name = 1 [json_name = "company_name"];
   */
  companyName = "";

  /**
   * 企業住所
   *
   * @generated from field: string address = 2;
   */
  address = "";

  /**
   * 企業ウェブサイトURL
   *
   * @generated from field: string website_url = 3 [json_name = "website_url"];
   */
  websiteUrl = "";

  /**
   * 企業説明
   *
   * @generated from field: string description = 4;
   */
  description = "";

  constructor(data?: PartialMessage<ResultClientInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.ResultClientInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "company_name", jsonName: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "website_url", jsonName: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResultClientInfo {
    return new ResultClientInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResultClientInfo {
    return new ResultClientInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResultClientInfo {
    return new ResultClientInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ResultClientInfo | PlainMessage<ResultClientInfo> | undefined, b: ResultClientInfo | PlainMessage<ResultClientInfo> | undefined): boolean {
    return proto3.util.equals(ResultClientInfo, a, b);
  }
}

